var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoulettePin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 112,
    viewBox: "0 0 177 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83327 53.417L90.5387 13.6904C91.8743 13.041 93.4268 14.0223 93.4132 15.5074L92.6707 96.4528C92.657 97.9378 91.0868 98.8905 89.7634 98.2167L8.80042 56.9979C7.32857 56.2486 7.34792 54.1392 8.83327 53.417Z",
    fill: "url(#paint0_linear_4067_517)",
    stroke: "#FEF9C9",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175 56.4023C175 85.6734 151.271 109.402 122 109.402C92.7289 109.402 69 85.6734 69 56.4023C69 27.1312 92.7289 3.40234 122 3.40234C151.271 3.40234 175 27.1312 175 56.4023Z",
    fill: "url(#paint1_linear_4067_517)",
    stroke: "#FEF9C9",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4067_517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.5 85.4023C137.792 85.4023 151 72.1947 151 55.9023C151 39.6099 137.792 26.4023 121.5 26.4023C105.208 26.4023 92 39.6099 92 55.9023C92 72.1947 105.208 85.4023 121.5 85.4023Z",
    fill: "url(#paint2_radial_4067_517)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4067_517",
    x: 88,
    y: 26.4023,
    width: 67,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4067_517",
    x1: 0.729531,
    y1: 55.1333,
    x2: 105,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5DD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#F5AF25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#B97F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4067_517",
    x1: 175,
    y1: 56.5,
    x2: 67,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425709,
    stopColor: "#242323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403F3E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4067_517",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.5 55.9023) scale(29.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F8F0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#E7D28E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#CCA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C3922E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoulettePin);
export default __webpack_public_path__ + "static/media/RoulettePin.7772a5011021b1b584a672f240dac433.svg";
export { ForwardRef as ReactComponent };